import "./components/accordion";
import "./components/slider";
import "./components/testimonials";
import "./components/lottie";
import "./components/hp-hero";
import "./components/hero-parent";
import "./components/lab-services-slider";
import "./components/manufacturing-services-slider";
import "./components/alternating-sections";
import "./components/why-choose-afton";
import "./components/sidenav-slider";
import "./components/roadmap-slider";
import "./components/history-slider";
import "./components/cta-banner";
import "./components/custom-components-slider";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin( ScrollSmoother );


import { observeAndAnimate, horizontalLoop } from "./components/utils";

if ( $( "body" ).hasClass( "home" ) ) {
  ScrollSmoother.create( {
    smooth: 1,
    effects: true,
  } );
}

// Generic Animation functions
function slideIn ( element ) {
  gsap.to( element, { translateX: 0 } );
}
function slideUp ( element ) {
  gsap.to( element, { translateY: 0 } );
}

// Observing and animating specific elements
observeAndAnimate( "g.hero-chevron-purple", slideIn );
observeAndAnimate( "g.cta-chevrons", slideIn );
